// Amplitude Browser SDK v2 implementation

import {
  init,
  setUserId,
  track,
  identify,
  Identify,
  reset,
} from '@amplitude/analytics-browser';
import config from '../config';

class AmpClient {
  async init() {
    try {
      await init(config.amplitudeApiKey, undefined, {
        includeUtm: true,
        defaultTracking: true,
      }).promise;
    } catch (error) {
      console.error('Amplitude v2 init failed:', error);
    }
  }

  async initUser(userInfo) {
    if (!userInfo?.userId) return;

    try {
      // Set Amplitude user ID
      setUserId(userInfo.userId);

      // Format signupDate
      const signupDateObj = new Date(userInfo.signupDate * 1000);
      const signupDate = `${signupDateObj.getFullYear()}-${
        signupDateObj.getMonth() + 1
      }-${signupDateObj.getDate()}`;

      // Create Amplitude Identify object
      const identifyObj = new Identify();
      identifyObj.set('gender', userInfo.userGender);
      identifyObj.set('Name', userInfo.userName);
      identifyObj.set('SponsorName', userInfo.sponsorName);
      identifyObj.set('walletBalance', userInfo.walletBalance);
      identifyObj.set('signupDate', signupDate);
      identifyObj.set('version', config.version);

      // Send to Amplitude
      await identify(identifyObj).promise;

      // Send to Clevertap
      if (window.clevertap?.onUserLogin?.push) {
        window.clevertap.onUserLogin.push({
          Site: {
            Gender:
              userInfo.userGender?.length > 1
                ? userInfo.userGender.charAt(0).toUpperCase()
                : 'M',
            Name: userInfo.userName,
            SponsorName: userInfo.sponsorName,
            sponsorId: userInfo.sponsorId,
            signupDate:
              signupDate && new Date(signupDate)
                ? `$D_${new Date(signupDate).valueOf()}`
                : '',
            Identity: userInfo.userId,
            userId: userInfo.userId,
            version: config.version,
            Email: userInfo.userEmail,
            Phone: `+91${userInfo.userPhone}`,
            DOB: userInfo.dateOfBirth ? new Date(userInfo.dateOfBirth) : null,
          },
        });
      }
    } catch (error) {
      console.error('Amplitude v2 initUser failed:', error);
    }
  }

  async logEvent(event, props) {
    try {
      await track(event, props || {}).promise;
      if (window.clevertap) {
        window.clevertap.event.push(event, props || {});
      }
    } catch (error) {
      console.error('Amplitude v2 logEvent failed:', error);
    }
  }

  async logoutUser() {
    try {
      reset();
      await init(config.amplitudeApiKey, undefined, {
        includeUtm: true,
        defaultTracking: true,
      }).promise;

      if (window.clevertap?.logout) {
        window.clevertap.logout();
      }
    } catch (error) {
      console.error('Amplitude v2 logoutUser failed:', error);
    }
  }
}

let client;

const initializeAmplitudeClient = () => {
  if (!client) {
    client = new AmpClient();
  }
  return client;
};

export { initializeAmplitudeClient };
